import productTypeApi from '../../api/productType';
import ErrorHelper from '../../helpers/ErrorHelper';

let loadingStandardPlaceholders = false;
export default {
    namespaced: true,
    state: {
        standardPlaceholders: null,
    },
    mutations: {
        setStandardPlaceholders(state, placeholders) {
            state.standardPlaceholders = placeholders;
        },
    },
    getters: {
        getStandardPlaceholders(state) {
            return state.standardPlaceholders;
        },
    },
    actions: {
        loadStandardPlaceholders({ commit, state }) {
            if (loadingStandardPlaceholders) {
                return;
            }
            if (!state.standardPlaceholders) {
                loadingStandardPlaceholders = true;
                productTypeApi
                    .fetchStandardDescriptionPlaceholders()
                    .then((response) => {
                        commit(
                            'productTypeSettings/setStandardPlaceholders',
                            response.data.data,
                            { root: true }
                        );
                        loadingStandardPlaceholders = false;
                    });
            }
        },
    },
};
